import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '@material-ui/core';
import withStyles from '@material-ui/core/styles/withStyles';
import { CheckCircle } from '@material-ui/icons';
import { getStringFromObject } from '../../../constants/lodashUtils';

const styles = () => ({
    parent: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
    },
    labelDiv: {
        width: '11em',
        marginRight: '1em',
    },
    fieldDiv: {
        flexGrow: '1',
        color: 'black',
    },
});

class FormikCompleteIcon extends React.PureComponent {
    render() {
        const {
            form: { values },
            field: { name },
            tooltip,
        } = this.props;
        const checkCompleted = getStringFromObject(name, values);

        if (checkCompleted) {
            return (
                <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                    <Tooltip
                        title={tooltip}
                    >
                        <CheckCircle
                            nativeColor="#2E7D32"
                        />
                    </Tooltip>
                </div>
            );
        }
        return <React.Fragment />;
    }
}

FormikCompleteIcon.propTypes = {
    form: PropTypes.object.isRequired,
    field: PropTypes.object.isRequired,
    tooltip: PropTypes.string,
};

FormikCompleteIcon.defaultProps = {
    tooltip: '',
};

export default withStyles(styles)(FormikCompleteIcon);
